import { ICommonModalData } from "config";

export enum ConversionGradingModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}

export interface IConversionGradingModalData
  extends ICommonModalData<ConversionGradingModalMode> {
  id?: number;
}
